import React from "react";
import { LineSegmentMsgForm } from "../../../organisms/externalApi/line/LineSegmentMsgForm";
import { LineSegmentDeliveryLayout } from "../../../template/LineSegmentDeliveryLayout";

export const LineSegmentMsg: React.FC = () => (
  <LineSegmentDeliveryLayout FormComponent={LineSegmentMsgForm} />
);